import { useRef } from 'react';

import { trackingUtils } from '@debijenkorf/dbk-common';
import { useTracking } from '@debijenkorf/hooks';
import { Ribbon } from '@debijenkorf/ribbon';

import type { RibbonMapperProps } from '@/services/mappers/common/ribbonMapper';

type RibbonWrapperProps = {
  ribbon: RibbonMapperProps;
  pageType?: string;
};

export const RibbonWrapper = ({ ribbon, pageType }: RibbonWrapperProps) => {
  const ref = useRef(null);
  const text = ribbon.text ?? '';

  const trackingData = {
    id: `${pageType}-ribbon`,
    name: `ribbon-${text}`,
    title: text,
  };

  const { onClickEvent } = useTracking({
    targetRef: ref,
    displayEventData: trackingUtils.viewPromotionEvent(trackingData),
    clickEventData: trackingUtils.selectPromotionEvent(trackingData),
  });

  return (
    <Ribbon
      text={text}
      isVisible
      ref={ref}
      // BE doesn't return the correct typings for variant, so we cast it to any.
      variant={ribbon.variant as any}
      cta={
        ribbon.cta
          ? {
              ...ribbon.cta,
              callback: onClickEvent,
            }
          : undefined
      }
    />
  );
};
